import { FeatureSectionType, Testimonial } from "../../components/types";

export const featureSections: FeatureSectionType[] = [
  {
    src: "",
    fallbackSrc: "/landing_page_assets/why_verse/WhyVerse1.png",
    title: "Build something meaningful & net positive.",
    description: [
      "Too much software doesn't end up being a clear net positive on the world.",
      "We're building something truly new, not the hundredth iteration of a CRM or social app. The product we're building positively impacts patient & clinician lives every single day.",
    ],
    features: [],
    hasButton: false,
    imageClassName: "tw-aspect-[550/600] tw-max-h-[600px] tw-max-w-[550px]",
  },
  {
    src: "",
    fallbackSrc: "/landing_page_assets/why_verse/WhyVerse2.png",
    title: "Work with amazing colleagues.",
    description: [
      "We have a maniacal focus on having amazing folks in every position and level of seniority. You'll have a chance to work with colleagues you learn from every day.",
    ],
    className: "min440:tw-flex-row-reverse",
    features: [],
    hasButton: false,
    imageClassName: "tw-aspect-[550/600] tw-max-h-[600px] tw-max-w-[550px]",
  },
  {
    src: "",
    fallbackSrc: "/landing_page_assets/why_verse/WhyVerse3.png",
    title: "See career growth.",
    description: [
      "Working at Verse isn't the easiest job you can get. But, we reward consistent outperformance quickly & aggressively.",
    ],
    features: [],
    hasButton: false,
    imageClassName: "tw-aspect-[550/600] tw-max-h-[600px] tw-max-w-[550px]",
  },
  {
    src: "",
    fallbackSrc: "/landing_page_assets/why_verse/WhyVerse4.png",
    title: "Work in a low-bureaucracy environment.",
    description: [
      "Our talent-dense team allows us to limit the amount of bureaucracy in our organization.",
    ],
    className: "min440:tw-flex-row-reverse",
    features: [],
    hasButton: false,
    imageClassName: "tw-aspect-[550/600] tw-max-h-[600px] tw-max-w-[550px]",
  },
];

export const testimonials: Testimonial[] = [
  {
    text: "Working at Verse is genuinely rewarding. We have a talented team, a meaningful mission and autonomy in contributing to a fast-growing product. Best of all, engineers here don't just get tickets to implement—we get actual problems to solve.",
    author: "Furrukh",
    role: "Senior Software Engineer",
    bgColor: "tw-bg-blue-2",
    textColor: "tw-text-white",
    imageSrc: "landing_page_assets/avatars/Furrukh.png",
  },
  {
    text: "Working as a designer at Verse is an exciting and rewarding challenge. We have a high degree of product ownership and can make a direct impact on the business. It's incredibly fulfilling to see how design can shape the entire product-service system from end to end.",
    author: "Sean",
    role: "Product Designer",
    bgColor: "tw-bg-[#005C99]",
    textColor: "tw-text-white",
    imageSrc: "landing_page_assets/avatars/Sean.png",
  },
  {
    text: "Working at Verse has been an incredible learning experience. I've grown quickly, tackled meaningful challenges, and felt truly supported by a fast-moving, collaborative, and low-ego team.",
    author: "Caroline",
    role: "Operations Manager",
    bgColor: "tw-bg-[#CCEBFF]",
    textColor: "tw-text-black",
    imageSrc: "landing_page_assets/avatars/Caroline.png",
  },
  {
    text: "Incredible mission and strong product-market fit. Our product truly makes a difference in our customers' and patients' lives, great work-life balance, and a team that truly cares. Highly recommend working here!",
    author: "Adam",
    role: "Customer Success Team Lead",
    bgColor: "tw-bg-[#003D66]",
    textColor: "tw-text-white",
    imageSrc: "landing_page_assets/avatars/Adam.png",
  },
];

export const officeImages = [
  {
    src: "/landing_page_assets/about/About9.png",
    className:
      "tw-row-span-3 tw-h-full tw-w-full tw-rounded-[2em] tw-object-cover",
  },
  {
    src: "/landing_page_assets/why_verse/WhyVerse6.png",
    className:
      "tw-row-span-2 tw-h-full tw-w-full tw-rounded-[2em] tw-object-cover",
  },
  {
    src: "/landing_page_assets/about/About14.png",
    className:
      "tw-row-span-2 tw-h-full tw-w-full tw-rounded-[2em] tw-object-cover",
  },
  {
    src: "/landing_page_assets/about/About10.png",
    className:
      "tw-col-span-2 tw-h-full tw-w-full tw-rounded-[2em] tw-object-cover",
  },
];
